import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';

// Ícones/cores na mesma ordem de t.pillars.items
const PILLAR_STYLES = [
  { icon: '🎮', iconBg: 'rgba(123,92,255,0.15)' },
  { icon: '📋', iconBg: 'rgba(255,107,53,0.15)' },
  { icon: '💚', iconBg: 'rgba(45,220,180,0.15)' },
];

const Pillars = () => {
  const { t } = useLanguage();

  return (
    <section className="sec pillars-bg">
      <div className="sec-header">
        <div className="sec-eyebrow">{t.pillars.eyebrow}</div>
        <h2 className="sec-title">{t.pillars.title}</h2>
      </div>
      <div className="pillars-grid">
        {t.pillars.items.map((pillar, i) => (
          <div className="pillar" key={pillar.title}>
            <div className="pillar-icon" style={{ background: PILLAR_STYLES[i].iconBg }}>{PILLAR_STYLES[i].icon}</div>
            <h3>{pillar.title}</h3>
            <p>{pillar.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Pillars;
